module.exports = __webpack_public_path__ + "img/1440.2ee1e603.jpg";